module.exports = __webpack_public_path__ + "static/media/NHS_Coronavirus_Absence_Tracker_[External]-User_Guidance.04ad7c87.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/components/document/NHS_Coronavirus_Absence_Tracker_[External]-User_Guidance.pdf
// module id = 97
// module chunks = 0